import React from "react";
import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, resolveImage } from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { PageLoader, EmptyState } from "@/components/common";
import { RotateCcw, Check, X } from "lucide-react";

export function AdminRelist() {
  const qc = useQueryClient();
  const { data: reqs, isLoading } = useQuery({ queryKey: ["admin-relist"], queryFn: () => apiFetch("/admin/relist-requests") });

  const decide = async (id, approve) => {
    const reason = approve ? "Approved" : (window.prompt("Reason for declining?") || "").trim();
    if (!approve && !reason) return;
    try {
      await apiFetch(`/admin/relist-requests/${id}/decision`, { method: "POST", body: JSON.stringify({ approve, reason }) });
      toast.success(approve ? "Relisted" : "Declined");
      qc.invalidateQueries({ queryKey: ["admin-relist"] });
    } catch (err) { toast.error(err.message); }
  };

  if (isLoading) return <PageLoader />;

  return (
    <div className="space-y-2">
      {reqs.length === 0 ? <EmptyState icon={RotateCcw} title="No relist requests" /> : reqs.map((r) => (
        <div key={r.id} className="flex gap-3 rounded-2xl border border-border p-3" data-testid={`relist-${r.id}`}>
          <div className="h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-secondary">{r.listing?.images?.[0] && <img src={resolveImage(r.listing.images[0])} alt="" className="h-full w-full object-cover" />}</div>
          <div className="min-w-0 flex-1">
            {r.listing ? <Link to={`/listing/${r.listing.id}`} className="truncate font-medium hover:underline">{r.listing.title}</Link> : <p>Listing removed</p>}
            <p className="text-sm text-muted-foreground">"{r.reason}"</p>
            <p className="text-xs text-muted-foreground">{r.seller?.name} · {timeAgo(r.created_at)}</p>
          </div>
          <div className="flex shrink-0 flex-col gap-1.5 self-center">
            <button onClick={() => decide(r.id, true)} className="flex items-center gap-1 rounded-lg bg-price px-3 py-1.5 text-xs font-semibold text-white" data-testid={`approve-relist-${r.id}`}><Check className="h-3.5 w-3.5" />Approve</button>
            <button onClick={() => decide(r.id, false)} className="flex items-center gap-1 rounded-lg bg-secondary px-3 py-1.5 text-xs font-semibold" data-testid={`decline-relist-${r.id}`}><X className="h-3.5 w-3.5" />Decline</button>
          </div>
        </div>
      ))}
    </div>
  );
}
